import React, { useEffect } from 'react';

import { Box, Button, Divider, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ReactHookFormInput from 'common/components/form/ReactHookFormInput';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validate';

import EmailFieldList from './EmailFieldList';
import PhoneFieldList from './PhoneFieldList';

const FormContainer = ({
    creditId,
    contactId,
    disabled = false,
    handleClickCloseForm,
    initialValues,
    isSaving,
    save,
}) => {
    const { t } = useTranslation();
    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    const onSubmit = (values) => {
        save({ ...values, id: contactId, creditId: creditId });
    };

    useEffect(() => reset(initialValues), [initialValues, reset]);

    return (
        <Stack component="form" onSubmit={handleSubmit(onSubmit)}>
            <ReactHookFormInput
                control={control}
                name="name"
                label={`${t('Name')} *`}
                disabled={disabled}
                placeholder={t('Enter name')}
            />

            <ReactHookFormInput
                control={control}
                name="first_lastname"
                label={`${t('Last name')} *`}
                disabled={disabled}
                placeholder={t('Enter last name')}
            />

            <ReactHookFormInput
                control={control}
                name="second_lastname"
                label={t('Second last name')}
                disabled={disabled}
                placeholder={t('Enter last name')}
            />

            <ReactHookFormInput
                control={control}
                name="business_name"
                label={t('Business name')}
                disabled={disabled}
                placeholder={t('Business name')}
            />

            <PhoneFieldList
                control={control}
                name="telephones"
                placeholder={t('Phones')}
            />

            <EmailFieldList
                control={control}
                name="emails"
                placeholder={t('Emails')}
            />

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                    justifyContent: 'end',
                }}
            >
                <Button
                    color="secondary"
                    onClick={handleClickCloseForm}
                    variant="text"
                >
                    {t('Cancel')}
                </Button>
                {!disabled && (
                    <Button
                        disabled={isSaving}
                        type="submit"
                        variant="contained"
                    >
                        {t('Save')}
                    </Button>
                )}
            </Box>
        </Stack>
    );
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValues,
    isSaving: selectors.getIsSavingItem,
});

const mapDispatchToProps = (dispatch) => ({
    save: (values) => dispatch(actions.save(values)),
});

FormContainer.propTypes = {
    contactId: PropTypes.number,
    creditId: PropTypes.string,
    disabled: PropTypes.bool,
    handleClickCloseForm: PropTypes.func,
    initialValues: PropTypes.object,
    isSaving: PropTypes.bool,
    save: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
